import { NgModule } from '@angular/core';

import { LoginModule } from 'app/main/auth/login/login.module';
import { MailConfirmModule } from 'app/main/auth/mail-confirm/mail-confirm.module';
import { ForgotPasswordModule } from 'app/main/auth/forgot-password/forgot-password.module';

@NgModule({
    imports: [
        // Authentication
        LoginModule,
        ForgotPasswordModule,
        MailConfirmModule
    ]
})
export class AuthModule {
}
